import dayjs from 'dayjs'
import { trimEndZero } from '@u'
import { _transferBigDosageBarData } from '@u/reportHelperPump'

const _cache = {
  allHeight: 10
}

function _valueTxt(_v) { // 如果3.00001，将其四舍五入之后变成3
  const v = +_v
  if (Number.isNaN(v)) {
    return ``
  } else {
    const rounded = v.toFixed(3)
    const rst = trimEndZero(rounded)
    return rst
  }
}

class Rect {
  constructor(rectBarArr = [], extra = {}) { // 左下角为坐标系原点
    const { stime = 0, etime = 0, h = 0, isLabel = false, isBasal = false, oneBarWidth = (15 * 60 * 1000) } = extra
    if (!stime || !etime) {
      console.error(`[逻辑错误]rect构造函数的入参extra要有stime和etime，从而能限定整个画布的宽度`)
      return null // return null，从而能更容易让逻辑体现出错误(null.x会报错)
    }
    const allWidth = etime - stime // 时间戳之差(微秒)
    const allHeight = h || 10 // 高度
    _cache['allHeight'] = allHeight
    
    const [p1 = {}, p2 = {}] = rectBarArr
    const p2copy = { ...p2 }
    delete p2copy['xAxis']
    delete p2copy['yAxis']

    let width
    let height
    let x
    let y

    // const { xAxis, yAxis, tv, td, groupId, extendId, type } = p2
    const { xAxis, yAxis, tv, tvTxt, td } = p2
    
    if (!isLabel) {
      if (!isBasal) {
        // 非"文本盒子": 大剂量柱形图
        x = p1.xAxis // 时间戳(微秒)
        width = xAxis - x
        height = yAxis
        y = 0 
      } else {
        // 非"文本盒子": 基础率的矩形或者临时基础率的矩形
        x = p1.xAxis // 时间戳(微秒)
        width = xAxis - x
        height = yAxis
        y = 0 
      }
    } else {
      if (!isBasal) {
        // "文本盒子": 大剂量label所占据的'矩形空间'
        const { isDualFirstRecord, dualExtendValue, dualExtendDuration } = p2
        const _oneBar = 21
        const _oneStringWidth = Math.ceil((11.2 / _oneBar) * oneBarWidth)
        const _oneDotRatio = 0.95 // 小数点跟0-9的数字宽度比例
        const _oneCommaWidth = _oneStringWidth // 一个逗号的宽度,或者说是一个|的宽度
        const _oneTabWidth = Math.ceil((10.8 / _oneBar) * oneBarWidth)
        let _oneDuration = Math.ceil((80 / _oneBar) * oneBarWidth)
        // console.error(`duration标签值td: ${td}, tv: ${tv}, tvTxt: ${tvTxt}, p2: `, p2)
        let durationLabelL = 0
        let allTextWidth = 0

        if (isDualFirstRecord) {
          const tmp = _valueTxt(tv)
          const tvl = /^[0-9]+\.[0-9]+/.test(tmp) ? (tmp.length - 1 + _oneDotRatio) : (tmp.length)
          allTextWidth = tvl * _oneStringWidth

          // 10,10 30m
          const extendV = dualExtendValue
          if (extendV) {
            const tmp = _valueTxt(extendV)
            const extendVL = /^[0-9]+\.[0-9]+/.test(tmp) ? (tmp.length - 1 + _oneDotRatio) : (tmp.length)
            allTextWidth += (extendVL * _oneStringWidth + _oneTabWidth + _oneCommaWidth)
          }

          // 再判断是否需要显示durtion
          if (dualExtendDuration) { // dualExtendDuration有，所以td也有。并且td就是延长量的duration(已经转化过可读性后的text)
            durationLabelL = `${td}`.length

            if (durationLabelL <= 3) {
              _oneDuration /= 2
            }

            // 包含duration长度
            allTextWidth += (_oneTabWidth + _oneDuration)            
          }
        } else {
          const tmp = _valueTxt(tv)
          const tvl = /^[0-9]+\.[0-9]+/.test(tmp) ? (tmp.length - 1 + _oneDotRatio) : (tmp.length)
          allTextWidth = tvl * _oneStringWidth
          
          if (td) {
            durationLabelL = `${td}`.length

            if (durationLabelL <= 3) {
              _oneDuration /= 2
            }
          } 
          if (td) {
            allTextWidth += (_oneTabWidth + _oneDuration)
          }
        }

        // if (+tv - 2 === 0 && p1.xAxis - 1697694061000 >= 0 && p1.xAxis - 1697696941000 <= 0) {
        //   debugger
        // }
        const distance = 0.2
        x = p1.xAxis // 时间戳(微秒)
        // if (groupId === '33c168bcd1b74e2b9e71a8db1b683b36') {
        //   debugger
        // }
        width = allTextWidth
        height = (23 / 200) * allHeight
        y = +yAxis + distance

        // 将此标签对应的bar的信息打进去，从而之后给label画markline(辅助线)时候需要使用
        Object.assign(p2copy, {
          barStartX: p1.xAxis,
          barWidth: p2.xAxis - p1.xAxis,
          barHeight: p2.yAxis
        })
      } else {
        // "文本盒子": 临时基础率的label矩形
        const text = `${tvTxt}`
        const allTextWidth = Rect.getTempBasalTitleWidth(text, { oneBarWidth })
        
        const distance = 0
        const barW = p2.xAxis - p1.xAxis
        x = p1.xAxis // 时间戳(微秒)
        // if (groupId === '33c168bcd1b74e2b9e71a8db1b683b36') {
        //   debugger
        // }
        width = allTextWidth
        height = (23 / 200) * allHeight
        y = +yAxis + distance

        // 将此标签对应的bar的信息打进去，从而之后给label画markline(辅助线)时候需要使用
        Object.assign(p2copy, {
          barStartX: p1.xAxis + allTextWidth / 2 - barW / 2,
          barWidth: barW,
          barHeight: p2.yAxis
        })
      }
    }

    Object.assign(this, p2copy, {
      width, height, x, y, ystart: y, allWidth, allHeight, isLabel: !!isLabel, isBasal: !!isBasal, xTxtNew: dayjs(x).format('MM/DD HH:mm:ss')
    })
  }

  static findMaxOverlapRectangleAndArea(currentRect, rectangles) {
    let maxOverlapArea = 0
    let maxOverlapRect = null

    for (const rect of rectangles) {
      const overlapArea = Rect.calculateOverlapArea(currentRect, rect)

      if (overlapArea > maxOverlapArea) {
        maxOverlapArea = overlapArea
        maxOverlapRect = rect
      }
    }

    return {
      rect: maxOverlapRect,
      area: maxOverlapArea
    }
  }

  static calculateOverlapArea(rectA, rectB) {
    const overlapWidth = Math.max(0, Math.min(rectA.x + rectA.width, rectB.x + rectB.width) - Math.max(rectA.x, rectB.x))
    const overlapHeight = Math.max(0, Math.min(rectA.y + rectA.height, rectB.y + rectB.height) - Math.max(rectA.y, rectB.y))

    return overlapWidth * overlapHeight
  }

  static packRectangles(rectangles, canvasWidth, canvasHeight, bars = []) { // bars是需要避开的矩形
    // console.error(`packedRectangles, bars.length: ${bars.length}`)
    const packedRectangles = []
    const unpack = []

    const rl = rectangles.length
    // if (bars.length === 6) {
    //   debugger
    // }
    for (let i = 0; i < rl; i++) {
      const rect = rectangles[i]
      const alreadyArrs = [...new Set([...bars, ...packedRectangles])] // 去重
      const logIs = [0] // dev,test

      if (logIs.includes(i)) {
        console.error(`i=${i},alreadyArrs.length: ${alreadyArrs.length}, rectangles.length:${rl}`, {
          alreadyArrs,
          rectangles,
          rect
        })
      }

      const position = Rect.findAvailablePosition(rect, alreadyArrs, canvasWidth, canvasHeight)
      if (logIs.includes(i)) {
        console.error(`i=${i};alreadyArrs.length: ${alreadyArrs.length}, rectangles.length:${rl}`, {
          alreadyArrs,
          rect,
          canvasWidth,
          canvasHeight,
          rectangles,
          position
        })
      }
      
      if (position) {
        rect.x = position.x
        rect.y = position.y
        packedRectangles.push(rect)
      } else {
        unpack.push(rect)
      }
    }
    
    return {
      pack: packedRectangles,
      unpack
    }
  }

  static findAvailablePosition(rect, packedRectangles, canvasWidth, canvasHeight) {
    // const maxColumns = Math.floor((canvasWidth - rect.) / rect.width)
    // console.error(`findAvailablePosition, packedRectangles.length: ${packedRectangles.length}, canvasHeight: ${canvasHeight}`, {
    //   packedRectangles,
    //   rect
    // })
    
    // const _isDebugRect = (rect.td === '30m00s' && +rect.tv - 7 === 0) // dev,test
    // const _isDebugRect = (rect.td === '30m00s' && +rect.x === 1697683248000) // dev,test
    // const _isDebugRect = false

    const sx = rect.x
    const sy = rect.y
    const tv = rect.tv
    const tvy = _transferBigDosageBarData(tv)
    
    const durationLabel = rect && rect.td // !durationLabel的x不变，只改变y

    const xMoveGap = 1000 * 1 // x秒x秒移动位移

    const padTop = 0.2
    const rH = (canvasHeight - rect.height - padTop)
    const hratio = 1000 // 碰撞检测算法，垂直方向的步长
    const yMoveGap = (rH / hratio)

    if (!durationLabel) {
      // 立即量的标签: x不变，只改变y
      for (let row = 0; row < hratio; row++) {
        const x = sx
        const y = sy + (rH / hratio) * row        

        if ((y + rect.height + padTop) - _cache['allHeight'] > 0) {
          // 超出画布范围
          return null
        }

        const isOverlap = packedRectangles.find(packedRect => (
          (x + rect.width - packedRect.x > 0) &&
            (x - (packedRect.x + packedRect.width) < 0) &&
            (y + rect.height - packedRect.y > 0) &&
            (y - (packedRect.y + packedRect.height) < 0)
        ))
        
        if (!isOverlap) {
          // if (rect.name === '5.75,tv:8') {
          //   debugger
          // }

          return { x, y, tv, sy, tvy } 
        }
      }

      return null
    } else {
      // step1,先原先位置(同一个x)垂直方向寻找;找不到后再"左右震荡寻找"
      // step2,原先位置向左偏移n个p位移，然后再垂直方向寻找
      // step3,原先位置向右偏移n个p位移，然后再垂直方向寻找
      
      const maxColumns = rect.width * 1 // 标签能前后位移maxColumns / 2的位移
      const halfMaxColumnsCounts = Math.ceil((maxColumns / 2) / xMoveGap)
      
      for (let col = 0; col < halfMaxColumnsCounts; col++) {
        // step1,先原先位置(同一个x)垂直方向寻找;找不到后再"左右震荡寻找"
        if (col === 0) {
          // 垂直方向上查找
          const x = sx
          do {
            for (let row = 0; row < hratio; row++) {
              const y = sy + yMoveGap * row
              
              if ((y + rect.height + padTop) - _cache['allHeight'] > 0) {
                // 超出画布范围
                return null
              }

              const isOverlap = packedRectangles.find(packedRect => (
                (x + rect.width - packedRect.x > 0) &&
                  (x - (packedRect.x + packedRect.width) < 0) &&
                  (y + rect.height - packedRect.y > 0) &&
                  (y - (packedRect.y + packedRect.height) < 0)
              ))
              
              if (!isOverlap) {
                return { x, y, tv, sy, tvy } 
              }
            }
            /* eslint-disable-next-line */
          } while (false)        
        } else {
          // step2,原先位置向左偏移n个p位移，然后再垂直方向寻找
          do {
            const x = sx - col * xMoveGap
            for (let row = 0; row < hratio; row++) {
              const y = sy + yMoveGap * row

              if ((y + rect.height + padTop) - _cache['allHeight'] > 0) {
                // 超出画布范围
                return null
              }

              const isOverlap = packedRectangles.find(packedRect => (
                (x + rect.width - packedRect.x > 0) &&
                  (x - (packedRect.x + packedRect.width) < 0) &&
                  (y + rect.height - packedRect.y > 0) &&
                  (y - (packedRect.y + packedRect.height) < 0)
              ))
              
              if (!isOverlap) {
                return { x, y, tv, sy, tvy } 
              }
            }
            /* eslint-disable-next-line */
          } while (false)
          
          // step3,原先位置向右偏移n个p位移，然后再垂直方向寻找
          do {
            const x = sx + col * xMoveGap
            for (let row = 0; row < hratio; row++) {
              const y = sy + yMoveGap * row

              if ((y + rect.height + padTop) - _cache['allHeight'] > 0) {
                // 超出画布范围
                return null
              }

              const isOverlap = packedRectangles.find(packedRect => (
                (x + rect.width - packedRect.x > 0) &&
                  (x - (packedRect.x + packedRect.width) < 0) &&
                  (y + rect.height - packedRect.y > 0) &&
                  (y - (packedRect.y + packedRect.height) < 0)
              ))
              
              if (!isOverlap) {
                return { x, y, tv, sy, tvy } 
              }
            }
            /* eslint-disable-next-line */
          } while (false)
        }
      }
      
      return null
    }
  }

  static getTempBasalTitleWidth(tvTxt, extra = {}) {
    const { oneBarWidth = (15 * 60 * 1000) } = extra
    const _oneBar = 22
    const _oneStringWidth = Math.ceil((20 / _oneBar) * oneBarWidth * (3.2 / 4))
    const _oneTabWidth = Math.ceil((14 / _oneBar) * oneBarWidth)
    const _oneDuration = Math.ceil((80 / _oneBar) * oneBarWidth) // 03h03m 这样长的duration的长度

    const text = `${tvTxt}`
    let allTextWidth = 0
    const ts = text.split(' ')
    ts.forEach((str, i) => {
      const sl = str.length
      if (i === ts.length - 1) {
        // last one: 持续时间
        if (sl <= 3) {
          // 只有03h这样子
          allTextWidth += (_oneDuration / 2)
        } else {
          // 03m10s
          allTextWidth += _oneDuration
        }
      } else {
        // 值
        allTextWidth += (_oneStringWidth * sl)
      }
    })
    
    allTextWidth += _oneTabWidth

    return allTextWidth
  }
}
export default Rect
